import clsx from 'clsx';
import Button from 'components/button';
import styles from './styles.module.scss';

type BaseProps = {
  loading?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

type LoadMoreButtonProps =
  | (BaseProps & { label: string; per?: undefined; total?: undefined; loadedNum?: undefined })
  | (BaseProps & { label?: undefined; per: number; total: number; loadedNum: number });

const LoadMoreButton: React.FC<LoadMoreButtonProps> = (props) => {
  const { per, total, loading, label, loadedNum, onClick, className } = props;

  const getLabel = () => {
    if (typeof label === 'string') return label;
    else {
      const left = total;
      const canLoad = left > per ? per : left;

      return `ещё ${canLoad} из ${left}`;
    }
  };

  return (
    <Button
      loading={loading}
      onClick={onClick}
      label={getLabel()}
      variant='transparent'
      className={clsx(styles.button, className)}
    />
  );
};

export default LoadMoreButton;
